export const votingStore = {
    state: () => ({
        timestampLastVotingResultArrive: null,
    }),
    mutations: {
        setTimestampLastVotingResultArrive(state, payload) {
            state.timestampLastVotingResultArrive = payload;
        }
    }
}